<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
import type { TPopoverMenu } from '~/constants/www'

defineProps<{ menu: TPopoverMenu }>()

const popover = ref<HTMLDivElement | null>(null)
</script>

<template>
  <div
    :id="menu.menuId"
    ref="popover"
    :aria-label="`${menu.menuId} Submenu`"
    :class="
      twMerge(
        'dropdown-menu top-10 z-50 -translate-x-1/2 pt-6 left-1/2 absolute',
        $attrs.class as string,
      )
    "
  >
    <!-- Popover Arrow -->
    <div
      class="absolute left-1/2 top-4 h-4 w-4 -translate-x-1/2 rotate-45 bg-white shadow-[-3px_-5px_10px_-1px_rgba(0,0,0,0.1)]"
    />
    <div class="sm-height:max-h-[60vh]">
      <div
        data-testid="navigation-item-container"
        class="flex max-h-[550px] flex-col flex-wrap gap-x-6 gap-y-6 rounded-xl bg-white p-6 text-s-900 shadow-[3px_3px_10px_rgba(0,0,0,0.25)] xl:max-h-[560px] xl:p-8"
        :class="{}"
      >
        <slot />
      </div>
    </div>
  </div>
</template>
